import React, {useContext, useEffect, useRef, useState} from 'react';
import {Button, message, Modal, Spin, Tabs} from 'antd';
import {ClientBridge} from "./index";
import Controller from "./control/Controller";
import './App.css';
import SalesSheetSearch from "./browser/SalsesSheetSearch";
import Help from "./Wizard/Help";
import SimpleWizard from "./Wizard/SimpleWizard";
import {importAdSellerData} from "./lib/adSeller";
import {SubscribeMessage} from "./uiUtils/SubscribeMessage";
import packageJson from "../package.json"

const { TabPane }= Tabs;


const AppController = React.createContext({});
export {AppController};

export default function App(props) {
    const [tab, setTab] = useState("1");
    const {model,aodService,setCallbacks, mcc, mccLogin, wizard, active, mccNav} = useContext(ClientBridge);
    const controller = new Controller(aodService, model);
    const wizardRef = useRef();
    const salesSheetRef = useRef();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setCallbacks({
            openWizard: template=>{
                //wizardRef.current.resetWizard({template});
                wizardRef.current.loadTemplate(template);
                setTab('1');
            },
            loadAdSeller: loadAdSeller,
            clearAdvertisers: ()=>model.advertiser.empty(),  //harness testing
            getVersion: ()=>packageJson.version
        })
    }, []);

    function goToWizard(...args){
        controller.loadAdvertisers();
        wizardRef.current.resetWizard(...args);
        setTab('1');
    }

    function goToSalesSheet(...args){
        controller.loadAdvertisers();
        salesSheetRef.current.reset(...args);
        setTab('2');
    }

    function returnToSalesSheet(){
        controller.loadAdvertisers();
        setTab('2');
        salesSheetRef.current.refresh();
    }

    async function loadAdSeller(data) {
        // context includes advertiser, salesSheet, SpecAd, template as possible from data
        try {
            setLoading(true);
            const context = await importAdSellerData({data, controller, mcc, mccLogin, wizard});
            wizardRef.current.resetWizard(context);
            setTab('1');
        } catch (e) {
            message.error('Import of Pulse data failed!');
        } finally {
            setLoading(false);
        }
    }

    return (
        <AppController.Provider value={controller}>
            <Spin spinning={loading}>
                <Tabs type="card" onChange={setTab} activeKey={tab} tabBarStyle={{display:'none'}}
                    className={'aod_web_client'} >

                    <TabPane tab="Spec Ad Wizard" key="1">
                        <SimpleWizard ref={wizardRef}
                                      returnToSalesSheet={returnToSalesSheet}
                                      goToSalesSheet={goToSalesSheet}
                        />
                    </TabPane>

                    <TabPane tab="Presentations & Spec Ads" key="2" forceRender>
                        <SalesSheetSearch goToWizard={goToWizard}
                                          returnToWizard={()=>setTab('1')}
                                          ref={salesSheetRef}
                        />
                    </TabPane>

                    { false && <TabPane tab="Advertisers" key="3">
                        Advertisers in Grid<br/>
                        Get all with client support for filter / sort for now<br/>
                        drill down to Advertiser showing contacts & artwork<br/>
                        link to SS tab with Adv filter<br/>
                        (could later include account hiearchy if needed)<br/>
                    </TabPane> }

                    <TabPane tab={'Help'} key="4">
                        <Help/>
                    </TabPane>
                </Tabs>
            </Spin>
            <Modal
                title={"Request a Metro Wizard Trial!"}
                visible={mccLogin.user === 'guest' && active}
                closable={false}
                footer={[<Button key={'return'} type="primary"
                                 onClick={()=>mccNav.goView('creative')}>
                    OK
                </Button>]}
            >
                <SubscribeMessage/>
            </Modal>
        </AppController.Provider>
    );
}

